


























































































import { Component, Vue } from 'vue-property-decorator'
import * as Reveal from '@/assets/scripts/RevealOnScrollModule'

@Component
export default class Loader extends Vue {

	data() {
		return {
			PageTitle: "Loader"
		}
	}
	mounted() {
		new Reveal.revealOnScrollModule()
	}
}
